import { render, staticRenderFns } from "./eduExercise.vue?vue&type=template&id=c900f970&scoped=true"
import script from "./eduExercise.vue?vue&type=script&lang=js"
export * from "./eduExercise.vue?vue&type=script&lang=js"
import style0 from "./eduExercise.vue?vue&type=style&index=0&id=c900f970&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c900f970",
  null
  
)

export default component.exports